import de from './de.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };

export const insuranceI18nNamespace = 'insurance' as const;
export const insuranceResources = { de, en } as const;
